import { render } from "./CommuneData.vue?vue&type=template&id=5e6ae764&scoped=true"
import script from "./CommuneData.vue?vue&type=script&lang=js"
export * from "./CommuneData.vue?vue&type=script&lang=js"

import "./CommuneData.vue?vue&type=style&index=0&id=5e6ae764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6ae764"]])

export default __exports__